<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
	<circle cx="8" cy="8" r="8" />
</svg>
</template>